import { V2_ENDPOINT } from "@/consts";
import type { ListTiersResponse } from "@/types/billing";
import { useQuery } from "@tanstack/react-query";

export const tierKeys = {
  all: ["tiers"] as const,
};

export function useListTiers() {
  return useQuery({
    queryKey: tierKeys.all,
    queryFn: async () => {
      const res = await fetch(`${V2_ENDPOINT}/v1/tiers`);
      if (!res.ok) throw new Error("Failed to fetch tiers");
      const json: ListTiersResponse = await res.json();
      return json.data.tiers;
    },
    staleTime: 5 * 60_000, // tiers rarely change
  });
}
